<template>

  <section id="producto-main">
    <div class="container-fluid" style="padding: 0px;">

      <div v-if="isLoading">
        CARGANDO
      </div>
      <div v-else>

        <div>
          <br>
          <a style="margin-left:1em" href="#" @click.prevent="goBack">Volver</a>
        </div>

        <!-- Photo + Data -->
        <div class="row no-padding">
          <div class="col-lg-6">

            <!-- Carousel -->
            <div id="productoCarousel" class="carousel slide" data-ride="carousel">


              <div class="carousel-inner">

                <div class="item active" >
                  <img :src="getImage" class="" >
                </div>

                <div  class="item" v-for="photo in photos">
                  <img :src="photo.image" class="" >
                </div>


              </div>

              <a class="left carousel-control" href="#productoCarousel" data-slide="prev"><img class="icon-prev" src="/static/img/app/fa-arrow-left.png"></a>
              <a class="right carousel-control" href="#productoCarousel" data-slide="next"><img class="icon-next" src="/static/img/app/fa-arrow-right.png"></a>

            </div>

          </div>
          <div class="col-lg-6">

              <div class="box-producto-detalle">

                  <div class="product-badge-agotado" v-if="product.STOCK<=0">
                      <span>AGOTADO</span>
                  </div>

                  <!-- Breadcrum -->
                  <!-- <nav aria-label="breadcrumb" role="navigation">
                      <ol class="breadcrumb">
                          <li class="breadcrumb-item">Bazar</li>
                          <li class="breadcrumb-item active" aria-current="page">{{product.titulo}}</li>
                      </ol>
                  </nav> -->

                  <h1 class="product-name">
                      {{product.titulo}}
                  </h1>

                  <div class="box-product-price" v-if="product.PACK != '1'">
                        <span class="product-price">{{product.PRECIO | currency }} <small>+ IVA</small></span>
                      </div>
                      <div class="box-product-price" v-else>
                        <span class="product-price">PACK {{product.PRECIO | currency }} <small>+ IVA</small></span>
                      </div>

                  </div>


                  <div class="box-cantidad" v-if="product.STOCK>0">

                      <select class="" v-model="quantity">
                        <option :value="n" v-for="(n,index) in rangeStock" :key="index">{{n}} unidades</option>
                      </select>

                      <div class="btn-submit" id="btnAddToCart"  @click.prevent="quickAddToCart(product)">
                          AÑADIR AL CARRITO
                      </div>

                    <div style="margin-top:5px" v-if="(product.product_purchase_min)>1">
                      <p>Minimo de Compra: {{product.product_purchase_min}} Unidades</p>
                    </div>

                    <div style="margin-top:5px" v-if="product.product_purchase_max>1 && product.product_purchase_max<100">
                      <p>Maximo de Compra: {{product.product_purchase_max}} Unidades</p>
                    </div>


                  </div>

                  <div class="box-descripcion">

                      <div class="box-data">
                          <div class="title"><span style="color:#b9b9b9">Código Articulo:</span> <span  v-html="product.COD_ARTICU"></span></div>
                          <div class="title_color"><span style="color:#b9b9b9">Color:</span> <span  v-html="product.COLOR"></span></div>

                          <h1 class="product-name"><span  v-html="product.SINONIMO" style="font-weight:bold"></span> - <span  v-html="product.DESCRIPCIO"></span></h1>
                      </div>

                      <div class="separador"></div>

                      <div class="box-data" v-if="product.OBSERVACIONES">
                          <div class="title">INFORMACIÓN DEL PRODUCTO</div>
                          <br>
                          <div class="box-info">
                              <div class="value" v-html=observacion></div>
                          </div>
                      </div>

                  </div>

              </div>

          </div>
        </div>
      </div>
    </div>
  </section>


</template>

<script>
    import Api from '@/Api';
    import {baseUrl} from "../Api";
    export default {
        data(){
          return {
            productId:0,
            isLoading:false,
            quantity:1,
            photos:[],
            product:{}
          };
        },
        computed:{
          rangeStock(){

            let maxToShow = this.product.STOCK;
            let multiplier = (this.product.product_multiplier)?this.product.product_multiplier:1;

            var start = 1;

            //this.quantity = start;

            if (this.quantity===1)
            {
              if (this.product.product_purchase_min>1)
              {
                //this.quantity = this.product.product_purchase_min;
              }
            }


            if (this.product.product_purchase_max>1)
            {
              maxToShow = this.product.product_purchase_max;
            }


            var ans = [];

            for (let i = start; i <=  maxToShow; i++) {
              if (i % multiplier === 0)
              {
                ans.push(i);
              }
            }
            return ans;
          },
          getImage(){
            if (this.product.image==="")
              return '/static/img/noimage.jpg';
            return this.product.image;
          },
          observacion(){
            if (this.product.OBSERVACIONES)
              return this.product.OBSERVACIONES.replace(/\n/g, "<br />");
            return '';
          },
          productImage(){
            return baseUrl + this.product.imageURL_L_0;
          },
          actualStock(){
            return parseInt(this.product.STOCK)
          }
        },
        methods:{
          goBack(){
            this.$router.back();
          },
          imageExists(image_url,base){
              fetch(image_url)
              .then(res => {
                if (res.status===200)
                {

                this.photos.push({image:baseUrl + base});
                }

              }).catch(err => {

              });
          },
          quickAddToCart(product) {

            this.$store.dispatch("addToCart", {product: product, quantity: this.quantity}).then(product => {

                $("nav.micarrito, .overlay-micarrito").addClass("open");
                $("body").addClass("lock");

              //alert("added");
              /* this.$toasted.show("Item " + product.product.titulo + " agregado ", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                action: {
                  text: 'Deshacer',
                  onClick: (e, toastObject) => {
                    this.$store.dispatch("removeFromCart", {item: product}).then(product => {
                      toastObject.goAway(0);
                    });

                  }
                }
              });*/

            }).catch(err=>{
              this.$swal({
                title: 'Oops!',
                text: err,
                type: 'error',
              }).then((result) => {

              })
            });
          },
        },
        mounted(){
          this.productId = window.atob(this.$route.params.id);

          $(window).scrollTop(0);

          let userData = this.$route.params.product;

          if (userData)
          {

              this.product = userData;

               this.photos = [
                {image: baseUrl + this.product.imageURL_L_1},
                {image: baseUrl + this.product.imageURL_L_2},
                {image: baseUrl + this.product.imageURL_L_3}
              ];

              var start = 1;
              this.quantity = start;


              if (this.product.product_purchase_min>1)
              {
                this.quantity = this.product.product_purchase_min;
              }

          }else{


          Api().get('product?id=' + this.productId).then(data=>{

              this.product = data.data;


              var start = 1;
              if (this.product.COD_ARTICU.startsWith("13"))
                start = 2;

              if (this.product.COD_ARTICU.startsWith("31"))
                start = 2;

              this.quantity = start;


              if (this.product.product_purchase_min>1)
              {
                this.quantity = this.product.product_purchase_min;
              }


              this.photos = [
                {image: baseUrl + this.product.imageURL_L_1},
                {image: baseUrl + this.product.imageURL_L_2},
                {image: baseUrl + this.product.imageURL_L_3}
              ];



          }).catch(err=>{
            console.error(err);
            this.$router.push({name: 'Home'});
          });
          }



        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductDetailPage.vue